import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProductOverviewComponent } from '@features/product-detail/product-overview/product-overview.component';
import { ProductModule } from '@features/product/product.module';
import { SliderModule } from '@features/slider/slider.module';
import { StoreStockModule } from '@features/store-stock/store-stock.module';
import { FormElementsModule } from '@shared/form-elements/form-elements.module';
import { SharedModule } from '@shared/shared.module';
import { ShowMoreComponent } from '@shared/show-more/show-more.component';

import { ProductDetailsComponent } from './product-details/product-details.component';
import { GetCampaignIdPipe } from './product-overview/should-render-campaign-slider.pipe';
import { ProductSliderComponent } from './product-slider/product-slider.component';
import { ProductSpecificationsComponent } from './product-specifications/product-specifications.component';
import { SameDayDeliveryModule } from '@shared/same-day-delivery/same-day-delivery.module';
import { ReserveInStoreModule } from '@features/reserve-in-store/reserve-in-store.module';

import { ProductRelatedPropertiesComponent } from './product-related-properties/product-related-properties.component';
import { ProductInformationComponent } from '@features/product-detail/product-information/product-information.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormElementsModule,
        ProductModule,
        SliderModule,
        StoreStockModule,
        SameDayDeliveryModule,
        ReserveInStoreModule,
        ProductOverviewComponent,
        ProductDetailsComponent,
        ProductSpecificationsComponent,
        ShowMoreComponent,
        ProductSliderComponent,
        GetCampaignIdPipe,
        ProductRelatedPropertiesComponent,
        ProductInformationComponent
    ],
    exports: [ProductOverviewComponent]
})
export class ProductDetailModule {}
